import React from "react";
import {cn} from '../utils'

const StopCircleIcon = (
        {
            className,
            color
        }: {
            className?: string,
            color?: string
        } & React.SVGProps<SVGSVGElement>) => (
        <svg
            fill="none"
            height="21"
            viewBox="0 0 20 21"
            width="20"
            className={cn(className)}
            xmlns="http://www.w3.org/2000/svg">
            <path clipRule="evenodd"
                  d="m10 20.9121c5.5228 0 10-4.4771 10-10 0-5.52284-4.4772-9.999991-10-9.999991-5.52285 0-10 4.477151-10 9.999991 0 5.5229 4.47715 10 10 10zm-2.63682-12.41502c-.36318.44254-.36318 1.10004-.36318 2.41502 0 1.315 0 1.9725.36318 2.415.06649.0811.14078.1553.22179.2218.44254.3632 1.10004.3632 2.41503.3632 1.315 0 1.9725 0 2.415-.3632.081-.0665.1553-.1407.2218-.2218.3632-.4425.3632-1.1.3632-2.415 0-1.31498 0-1.97248-.3632-2.41502-.0665-.08101-.1408-.1553-.2218-.22179-.4425-.36318-1.1-.36318-2.415-.36318-1.31499 0-1.97249 0-2.41503.36318-.08101.06649-.1553.14078-.22179.22179z"
                  fill={color || "currentColor"} fillRule="evenodd"/>
        </svg>
    )
;

export {StopCircleIcon};